import { render } from "./PleaseSelectElement.vue?vue&type=template&id=80f03e6a"
import script from "./PleaseSelectElement.vue?vue&type=script&lang=js"
export * from "./PleaseSelectElement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__